import module from 'contabilidad/polizas/module.js'
import template from './template.html'

export class ContabilidadPolizasProvisiongastospagos {
  data = undefined
  Filtro = undefined
  clientes = undefined
  clientesFiltro = undefined
  cuentasBancarias = undefined
  proveedores = undefined
  results = undefined
  fechaInicio
  fechaFin
  idCliente
  cuentaBancaria
  opciones = {
    fecha_inicio: new Date(),
    fecha_fin: new Date(),
    ID_Cliente: undefined,
    CuentaBancaria: undefined,
  }
  catalogo = {
    empresas: [],
    cuentasBancarias: [],
    clientes: [],
  }

  constructor ($q, $catalogos, $dialog, $stateParams, $location, ContabilidadPolizas, provisionGastosPagosService) {
    this.$q = $q
    this.$dialog = $dialog
    this.$location = $location
    this.$catalogos = $catalogos
    this.$stateParams = $stateParams
    this.ContabilidadPolizasService = ContabilidadPolizas
    this.provisionGastosPagosService = provisionGastosPagosService
  }

  $onChanges (changes) {
    if (changes.fechaInicio && this.fechaInicio) this.opciones.fecha_inicio = this.fechaInicio
    if (changes.fechaFin && this.fechaFin) this.opciones.fecha_fin = this.fechaFin
    if (changes.idCliente && this.idCliente) this.opciones.ID_Cliente = this.idCliente
    if (changes.cuentaBancaria && this.cuentaBancaria) this.opciones.CuentaBancaria = this.cuentaBancaria
  }

  $onInit () {
    const promises = [
      this.$catalogos.get('cuentasBancarias')
        .then((response) => (this.cuentasBancarias = response)),
      this.ContabilidadPolizasService.obtenerClientes()
        .then((response) => (this.clientes = response)),
      this.$catalogos.get('clientes')
        .then((response) => (this.clientesFiltro = response)),
    ]

    if (this.fechaInicio && this.fechaFin && this.idCliente && this.cuentaBancaria) {
      promises.push(this.provisionGastosPagosService.obtenerInformacion(this.fechaInicio, this.fechaFin, this.idCliente, this.cuentaBancaria)
        .then(({data}) => this.data = data),
      )
    }

    this.promise = this.$q.all(promises)
      .then(() => {
        if (this.opciones.ID_Cliente) {
          this.filtarCuentasBancarias()
        }

        this.filtrar()
      })
  }

  exportar () {
    let cliente
    this.clientes.map((item) => {
      if (item.ID_Cliente === this.opciones.ID_Cliente) {
        cliente = item.Nombre
      }
    })
    this.$dialog.show('contabilidad.polizas.exportar', {
      data: this.results,
      fecha_inicio: this.opciones.fecha_inicio,
      // Se agregó ésta propiedad para indicar qué es lo que se va a exportar
      config: {
        fecha_inicio: this.opciones.fecha_inicio,
        fecha_fin: this.opciones.fecha_fin,
        clientes: cliente,
        archivo: 'Provision_Gastos_Pagos ' + this.opciones.fecha_inicio.toYMD(),
        tipo_poliza: 'provisionGastosPagos',
      },
    })
  }

  obtenerInformacion () {
    this.$location.search({
      fecha_inicio: this.opciones.fecha_inicio.toYMD(),
      fecha_fin: this.opciones.fecha_fin.toYMD(),
      ID_Cliente: this.opciones.ID_Cliente,
      CuentaBancaria: this.opciones.CuentaBancaria,
    })
  }

  filtarCuentasBancarias () {
    this.cuentas = this.cuentasBancarias.filter((item) => {
      return item.ID_Cliente === this.opciones.ID_Cliente
    })
  }

  filtarProveedores (data) {
    return data.reduce((prev, next) => {
      return prev.concat(prev.indexOf(next.Nombre_Proveedor) < 0 ? [next.Nombre_Proveedor] : [])
    }, [])
  }

  filtrar () {
    let results = this.data

    if (this.filtro)
      results = this.filtarPorProveedores(results)

    this.results = results
  }

  filtarPorProveedores (data) {
    return data.filter((item) => {
      return this.filtro.indexOf(item.Nombre_Proveedor) >= 0
    })
  }
}

module.component('contabilidadPolizasProvisiongastospagos', {
  controller: ContabilidadPolizasProvisiongastospagos,
  template,
  bindings: {
    fechaInicio: '<',
    fechaFin: '<',
    idCliente: '<',
    cuentaBancaria: '<',
  },
})




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/provisiongastospagos/component.js